import styled from 'styled-components';

import CalendarActions from './CalendarActions';

const StyledCalendarActions = styled(CalendarActions)`
    border-top: 0.1rem solid #d0d0d0;
    padding: 0.5rem;
    text-align: center;

    .btn {
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: 'Quicksand', sans-serif;
        font-weight: 700;
        line-height: 1.2;
        color: #fafafa;
        font-size: 1.3rem;
        letter-spacing: -0.02em;
        line-height: 1.75;
        user-select: none;
        background-color: #00a8e1;
        cursor: pointer;
        display: inline-block;
        font-weight: 400;
        min-height: 5rem;
        outline: 0;
        padding: 1.4rem 1rem 1.2rem;
        position: relative;
        text-align: center;
        text-transform: uppercase;
        vertical-align: top;
        padding: 0 0.5rem;
        margin: 0 0.5rem;
        width: 30%;
        border: 0.1rem solid ${(props) => props.theme.colours.primary};
        border-radius: ${(props) => props.theme.corners.full}px;
        overflow: hidden;

        &.btn-active {
            background-color: ${(props) => props.theme.colours.primary};
            color: ${(props) => props.theme.colours.white};
        }

        &.btn-active-selected {
            background-color: ${(props) => props.theme.colours.primary};
            color: ${(props) => props.theme.colours.white};
        }
    }
`;
export default StyledCalendarActions;
